import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Series } from '../models/series';
import { CoreResponse } from '../models/core-response';
import { map, tap } from 'rxjs/operators';
import { HelperService } from './helper.service';

@Injectable({
    providedIn: 'root'
})

export class SeriesService {
    private url: string = environment.apiEndpoint + '/Series';
    private series$: Observable<Series[]>;

    constructor(private http: HttpClient, private helperService: HelperService) {
    }
    
    resetCache() {
        this.series$ = null;
    }

    getSeriesIdByName(name: string): Observable<number> {
        return this.getAllSeries().pipe(map(series => series.find(x => x.name === name).id));
    }

    getAllSeries(): Observable<Series[]> {
        return this.helperService.getCached(this.series$, this.http.get<Series[]>(this.url));
    }

    insertSeries(series: Series): Observable<Series> {
        return this.http.post<Series>(this.url, series).pipe(tap(this.resetCache));
    }

    updateSeries(series: Series): Observable<number> {
        return this.http.put<number>(this.url, series).pipe(tap(this.resetCache));
    }

    deleteSeries(id: number): Observable<CoreResponse<number>> {
        return this.http.delete<CoreResponse<number>>(this.url + '/' + id).pipe(tap(this.resetCache));
    }
}

